require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./front-end-libraries-jquery-remove-classes-from-an-element-with-jquery.json") })
        }
      }, "path---front-end-libraries-jquery-remove-classes-from-an-element-with-jquery");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---front-end-libraries-jquery-remove-classes-from-an-element-with-jquery!./.cache/json/front-end-libraries-jquery-remove-classes-from-an-element-with-jquery.json
// module id = 2040
// module chunks = 231608221292675